export * from './kunde-sorter.component';
export * from './kunde-sorter.component.module';